import React from "react";

import { styled } from "@mui/material/styles";
import { Grid, Paper, Divider } from "@mui/material";

import AccountCard from "./AccountCard";

const Item = styled(Paper)(({ theme }) => ({
    margin: "20px",
    boxShadow: "0 10px 40px rgb(0 0 0 / 0.2)",
    borderRadius: "20px",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    height: "100%",
}));

const SocialAccounts = ({ google, facebook, twitter }) => {
    return (
        <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
            <Item>
                <AccountCard name="google" data={google} />
                <br />
                <Divider />
                {/* <AccountCard name="facebook" data={facebook} />
                <br />
                <Divider /> */}
                <AccountCard name="twitter" data={twitter} />
            </Item>
        </Grid>
    );
};

export default SocialAccounts;
